import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "col gap-10 mtop-02",
  style: {"margin-bottom":"0.4rem"}
}
const _hoisted_2 = {
  key: 0,
  class: "item-s",
  style: {"margin-top":"-0.1rem"}
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  style: {"margin-top":"-0.1rem"}
}

import { computed } from 'vue';
import { useUiStore } from '@/stores/ui';
import { getSearchEnginePath, getDefaultSearchEngine }  from '@/functions/externalReference';
import { createReferenceSheetTitle } from '@/functions/resultSuggestion.js';
import { useCurrentEntryStore } from '@/stores/currentEntry';


export default /*@__PURE__*/_defineComponent({
  __name: 'refSheetList',
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const currentEntryStore = useCurrentEntryStore()
const uiStore = useUiStore()
const emits = __emit

const resultExpressions = computed(() => {
  return currentEntryStore.currCclSuggestionsFromResults?.expressions || []
})

function ordotypeSlug(expr, slug) {
	const keywords = expr.originalText
  uiStore.setReferenceSearchKewords(keywords)
  const url = 'https://www.ordotype.fr/pathologies/'  + slug
  uiStore.setReferenceFile(null)
	uiStore.setReferenceIFramePath(url)
  emits ('close')
}

function setResultExprSearch(expr) {
	const searchEngine = getDefaultSearchEngine(expr)
	const keywords = expr.originalText
	const path = getSearchEnginePath(searchEngine, keywords)
	uiStore.setReferenceSearchKewords(keywords)
  uiStore.setReferenceFile(null)
	uiStore.setReferenceIFramePath(path)
	emits ('close')
}

function setRefSheetSearch(expr) {
	const refSheet = expr.refSheet
  uiStore.setCurrRefSheet(refSheet)
	const searchEngine = getDefaultSearchEngine(expr)
  const keywords = createReferenceSheetTitle(refSheet)
	const path = getSearchEnginePath(searchEngine, keywords)
  uiStore.setReferenceSearchKewords(keywords)
  uiStore.setReferenceFile(null)
	uiStore.setReferenceIFramePath(path)	
  emits ('close')	
}

function showExternalRef(refSheet, url) {
	const keywords = createReferenceSheetTitle(refSheet)
  uiStore.setReferenceSearchKewords(keywords)
  uiStore.setCurrRefSheet(refSheet)
  uiStore.setReferenceFile(null)
  uiStore.setReferenceIFramePath(url)
  emits ('close')
}

function showInternalRef(refSheet, refFile) {
	const keywords = createReferenceSheetTitle(refSheet)
  uiStore.setReferenceSearchKewords(keywords)
  uiStore.setCurrRefSheet(refSheet)
  uiStore.setReferenceIFramePath("")
  uiStore.setReferenceFile(refFile)
  emits ('close')	
}


return (_ctx: any,_cache: any) => {
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_list_group = _resolveComponent("list-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultExpressions.value, (resultExpr, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "w-full"
      }, [
        _createVNode(_component_list_group, {
          styles: "pad-s",
          onClick: ($event: any) => (setResultExprSearch(resultExpr))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_svg_item, {
              style: {"margin-top":"-0.3rem"},
              icon: "search",
              styles: "size-s main-m"
            }),
            _createVNode(_component_text_item, {
              txt: resultExpr.originalText,
              styles: "font-m main-m",
              class: "mleft-04"
            }, null, 8, ["txt"])
          ]),
          _: 2
        }, 1032, ["onClick"]),
        (resultExpr.refSheet)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_list_group, {
                styles: "pad-s",
                onClick: ($event: any) => (setRefSheetSearch(resultExpr))
              }, {
                default: _withCtx(() => [
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "mleft-15" }, null, -1)),
                  _createVNode(_component_svg_item, {
                    style: {"margin-top":"-0.1rem","margin-left":"-0.2rem"},
                    icon: "bookOpen",
                    styles: "size-s main-m"
                  }),
                  _createVNode(_component_text_item, {
                    txt: _unref(createReferenceSheetTitle)(resultExpr.refSheet),
                    styles: "font-m main-h",
                    class: "mleft-04"
                  }, null, 8, ["txt"])
                ]),
                _: 2
              }, 1032, ["onClick"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultExpr.refSheet.referenceFiles, (referenceFile, index) => {
                return (_openBlock(), _createBlock(_component_list_group, {
                  key: index,
                  styles: "pad-s",
                  onClick: ($event: any) => (showInternalRef(resultExpr.refSheet, referenceFile))
                }, {
                  default: _withCtx(() => [
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "mleft-15" }, null, -1)),
                    _createVNode(_component_svg_item, {
                      style: {"margin-top":"-0.1rem","margin-left":"-0.2rem"},
                      icon: "file",
                      styles: "main-m size-s"
                    }),
                    _createVNode(_component_text_item, {
                      class: "mleft-04 maxWidthIconText",
                      txt: referenceFile.title
                    }, null, 8, ["txt"])
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultExpr.refSheet.externalLinks, (externalLink, index) => {
                return (_openBlock(), _createBlock(_component_list_group, {
                  key: index,
                  onClick: ($event: any) => (showExternalRef(resultExpr.refSheet, externalLink.link))
                }, {
                  default: _withCtx(() => [
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mleft-15" }, null, -1)),
                    (externalLink.logoImage)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createElementVNode("img", {
                            src: externalLink.logoImage,
                            alt: "Logo",
                            style: {"width":"100%","height":"100%"}
                          }, null, 8, _hoisted_3)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createVNode(_component_svg_item, {
                            icon: "globe",
                            styles: "main-m size-s"
                          })
                        ])),
                    _createVNode(_component_text_item, {
                      class: "mleft-04 maxWidthIconText",
                      txt: externalLink.linkTitle
                    }, null, 8, ["txt"])
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ], 64))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})